import React, { CSSProperties, MouseEventHandler } from 'react';
import { TooltipWithIcon } from '../TooltipWithIcon';
import { StyledLabel } from './style';

export interface LabelProps {
  className?: string;
  label: string | React.ReactNode;
  extraBold?: boolean;
  regular?: boolean;
  marginClassName?: string;
  center?: boolean;
  end?: boolean;
  onClick?: MouseEventHandler;
  italic?: boolean;
  styles?: CSSProperties;
  color?: string;
  bold?: boolean;
  themeColor?: boolean;
  clickable?: boolean;
  title?: boolean;
  tooltip?: string;
  required?: boolean;
}

export const Label = ({
  className,
  label,
  extraBold,
  regular,
  marginClassName,
  center,
  end,
  onClick,
  italic,
  styles,
  color,
  bold,
  themeColor,
  clickable,
  title,
  tooltip,
  required,
}: LabelProps) => {
  let completeClassName = '';

  if (className) {
    completeClassName += className;
  }

  if (bold) {
    completeClassName += ' regular-bold';
  }

  if (extraBold) {
    completeClassName += ' extra-bold';
  }

  if (themeColor) {
    completeClassName += ' theme-color';
  }

  if (marginClassName) {
    completeClassName += ' ' + marginClassName;
  }

  if (center) {
    completeClassName += ' center';
  }

  if (end) {
    completeClassName += ' end';
  }

  if (italic) {
    completeClassName += ' italic';
  }

  if (color) {
    completeClassName += ' ' + color;
  }

  if (clickable) {
    completeClassName += ' clickable';
  }

  if (title) {
    completeClassName += ' title';
    if (!color) {
      completeClassName += ' black';
    }
  }

  if (required) {
    completeClassName += ' required';
  }

  const labelContent = (
    <StyledLabel className={completeClassName} onClick={onClick} style={styles}>
      {label}
      {tooltip && <TooltipWithIcon title={tooltip} />}
    </StyledLabel>
  );

  return labelContent;
};
